import React from 'react'

import { Box, Skeleton } from '@mui/material'
import { useCustomerLeadsLimit } from 'features/customers/hooks/useCustomerLeadsLimit'

import { areLeadsUnlimited } from '@albacross/types'

import { quotaSeverity } from 'components/_base/QuotaUsage'

type CustomerLeadsLimitProps = {
  customerId: number
}

const CustomerLeadsLimit = ({ customerId }: CustomerLeadsLimitProps) => {
  const { data, isLoading } = useCustomerLeadsLimit(customerId)
  const { current, total } = data || {}

  if (isLoading) return <Skeleton variant="text" width={85} />
  if (!total) return '–'
  if (areLeadsUnlimited(total)) return `${current} / ∞`

  const severity = quotaSeverity(total, current)

  return (
    <Box component="span" sx={{ color: severity ? `${severity}.main` : undefined }}>
      {`${current} / ${total}`}
    </Box>
  )
}

export default CustomerLeadsLimit
